import type { FeatureName } from '../export-types/cleaned-types';

export const FEATURE_FLAGS = {
  MOYSKLAD_CATALOG: 'moysklad_catalog',
  TEST_FEATURE_FLAG: 'test_feature_flag',
  RETAIL_ORDERS_FEATURE_FLAG: 'retail_orders_feature_flag',
  WAITING_PAYMENT_PAGE_V2: 'waiting_payment_page_v2',
  PUBLIC_CATALOG: 'public_catalog',
  POIZON_CATALOG: 'poizon_catalog',
  MAINPAGE_1688_NEW_CLIENTS: 'mainpage_1688_new_clients',
  ONBOARDING: 'onboarding',
} as const satisfies Record<string, FeatureName>;

export const FEATURE_FLAG_LABELS: Partial<Record<FeatureName, string>> = {
  [FEATURE_FLAGS.MOYSKLAD_CATALOG]: 'Каталог «МойСклад»',
  [FEATURE_FLAGS.TEST_FEATURE_FLAG]: 'Тестовый флаг',
  [FEATURE_FLAGS.RETAIL_ORDERS_FEATURE_FLAG]:
    'Экспресс-доставка с таможенным оформлением (GBS)',
  [FEATURE_FLAGS.WAITING_PAYMENT_PAGE_V2]:
    'Новая страница «Ожидают оплаты» — Корзина',
  [FEATURE_FLAGS.PUBLIC_CATALOG]: 'Публичный каталог без регистрации',
  [FEATURE_FLAGS.POIZON_CATALOG]: 'Каталог Poizon',
  [FEATURE_FLAGS.MAINPAGE_1688_NEW_CLIENTS]: 'Главная 1688 для новых клиентов',
  [FEATURE_FLAGS.ONBOARDING]: 'Онбординг для клиентов',
};
